"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = searchTextFilter;
function searchTextFilter(target, search) {
  if (!search) {
    return true;
  }
  if (!target) {
    return false;
  }
  return target.toString().toLocaleLowerCase('tr').includes(search.toLocaleLowerCase('tr'));
}